import { RedirectProps } from 'react-router-dom';

export interface InternalRedirectPathProps {
  // Paths to redirect from
  fromPaths: string[];
  // Paths to redirect to
  to: string;
  // optional redirectProps.
  redirectProps?: RedirectProps;
}

export interface ExternalRedirectPathProps {
  // Paths to redirect from
  fromPaths: string[];
  // Full URL to redirect to
  toExternalUrl: string;
}

export type RedirectPathProps = InternalRedirectPathProps | ExternalRedirectPathProps;

export function isExternalRedirectPathProps(
  obj: RedirectPathProps
): obj is ExternalRedirectPathProps {
  return 'toExternalUrl' in obj;
}
